import {
  FormControl,
  FormLabel,
  Select,
  StackProps,
  VStack,
  chakra,
} from "@chakra-ui/react";
import { ReactElement } from "react";
import Heading from "../Heading";

interface AxisConfigProps extends StackProps {
  xAxis: string | null;
  yAxis: string | null;
  columns: Array<string>;
  onXAxisChange: (xAxis: string) => void;
  onYAxisChange: (xAxis: string) => void;
}

export default function AxisConfig(props: AxisConfigProps): ReactElement {
  const { columns, xAxis, yAxis, onXAxisChange, onYAxisChange, ...rest } =
    props;

  return (
    <VStack p="14" spacing="6" {...rest}>
      <Heading level={3} textAlign="center">
        Create a heatmap
      </Heading>
      <VStack>
        <FormControl display="flex" flexDirection="row" alignItems="center">
          <FormLabel flexShrink="0">Horizontal axis</FormLabel>
          <Select
            value={xAxis ?? undefined}
            bg="white"
            placeholder="Select an option"
            onChange={(evt) => onXAxisChange(evt.target.value)}
          >
            {columns.map((column) => (
              <chakra.option key={column} value={column}>
                {column}
              </chakra.option>
            ))}
          </Select>
        </FormControl>
        <FormControl display="flex" flexDirection="row" alignItems="center">
          <FormLabel flexShrink="0">Vertical axis</FormLabel>
          <Select
            value={yAxis ?? undefined}
            bg="white"
            placeholder="Select an option"
            onChange={(evt) => onYAxisChange(evt.target.value)}
          >
            {columns.map((column) => (
              <chakra.option key={column} value={column}>
                {column}
              </chakra.option>
            ))}
          </Select>
        </FormControl>
      </VStack>
    </VStack>
  );
}
